var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skeleton-loading__wrapper"},_vm._l((_vm.items),function(item){return _c('div',{key:(item + "-skeleton"),staticClass:"skeleton-loading rounded my-2",style:({
      height: _vm.computedHeight
    })})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }